//ported from https://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side
export const getOrientationFromExifData = file => {
  let buffer = dataURItoBuffer(file)
  var view = new DataView(buffer)
  if (view.getUint16(0, false) != 0xffd8) {
    return 1 //not jpeg
  }
  var length = view.byteLength,
    offset = 2
  while (offset < length) {
    if (view.getUint16(offset + 2, false) <= 8) return 1 //not defined
    var marker = view.getUint16(offset, false)
    offset += 2
    if (marker == 0xffe1) {
      if (view.getUint32((offset += 2), false) != 0x45786966) {
        return 1 //not defined
      }

      var little = view.getUint16((offset += 6), false) == 0x4949
      offset += view.getUint32(offset + 4, little)
      var tags = view.getUint16(offset, little)
      offset += 2
      for (var i = 0; i < tags; i++) {
        if (view.getUint16(offset + i * 12, little) == 0x0112) {
          return view.getUint16(offset + i * 12 + 8, little)
        }
      }
    } else if ((marker & 0xff00) != 0xff00) {
      break
    } else {
      offset += view.getUint16(offset, false)
    }
  }
  return 1 //not defined
}

//ported from https://stackoverflow.com/questions/12168909/blob-from-dataurl
function dataURItoBuffer(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1])

  // separate out the mime component
  var mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)

  // create a view into the buffer
  var ia = new Uint8Array(ab)

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return ab
}

